import { Routes } from '@angular/router';

import { AuthGuard } from '@plugins/client/auth';
import { AppGuard } from '@plugins/client/routing/app.guard';
import { createTranslationGuard } from '@plugins/client/translate/guards';

import { instanceResolver } from './resolvers';

const backofficeImport = () =>
  import('./backoffice/backoffice.component').then(
    (im) => im.BackofficeComponent,
  );
const frontofficeImport = () =>
  import('./frontend/frontend.component').then((im) => im.FrontendComponent);

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'admin',
        canActivate: [AuthGuard, AppGuard],
        canActivateChild: [createTranslationGuard(backofficeImport)],
        resolve: { instance: instanceResolver },
        data: { role: 'editor' },
        loadChildren: () => import('./backoffice/backoffice.routes'),
      },
      {
        path: '',
        canActivate: [AuthGuard, AppGuard],
        canActivateChild: [createTranslationGuard(frontofficeImport)],
        resolve: { instance: instanceResolver },
        loadChildren: () => import('./frontend/frontend.routes'),
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
];
